import { useContext, useState } from "react";
import GeneralContext from "../../../context/GeneralContext/GeneralContext";
import api from "../../../services/api";
import { displayMessage } from "../../../helpers/messages";
import SL_Button from "../../../components/buttons/Button";
import { SL_Input } from "../../../components/input/Input";
import { Form, Modal, Skeleton } from "antd";

export function CreateStretchingModal({ onCloseModal }) {
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const { setShowLoading } = useContext(GeneralContext);

	async function onFinishForm(values) {
		try {
			setShowLoading(true);
			await api.stretchings.create(values);
			await onCloseModal(true);
		} catch (error) {
			console.error("Erro ao criar alongamento:", error);
		} finally {
			setShowLoading(false);
		}
	}

	return (
		<Modal
			title={
				<div className="text-xl font-bold text-red-700 mr-3">
					{displayMessage("ADD_WORKOUT")} - {displayMessage("STRETCHING")}
				</div>
			}
			open={true}
			onCancel={() => onCloseModal(false)}
			centered={true}
			footer={
				<div className="flex flex-col ss:flex-row gap-2 justify-end">
					<SL_Button
						className="w-full ss:w-[150px] bg-gray-500 border-transparent"
						onClick={() => onCloseModal(false)}
					>
						{displayMessage("CLOSE")}
					</SL_Button>

					<SL_Button
						className="w-full ss:w-[150px] m-0 bg-red-600"
						onClick={() => form.submit()}
					>
						{displayMessage("END_REGISTER")}
					</SL_Button>
				</div>
			}
			maskClosable={false}
			width={600}
		>
			<Form
				onFinish={onFinishForm}
				layout="vertical"
				form={form}
				className={`flex gap-2 flex-col`}
			>
				{isLoading ? (
					<Skeleton active />
				) : (
					<>
						<Form.Item
							label={
								<span className="text-red-700 font-semibold">
									{displayMessage("WORKOUT_NAME")}:
								</span>
							}
							name="name"
							className={`w-full m-0`}
							required
							rules={[
								{
									required: true,
									message: displayMessage("NAME_MANDATORY"),
								},
							]}
							initialValue={""}
						>
							<SL_Input type="text" className="text-red-700" />
						</Form.Item>

						<Form.Item
							label={
								<span className="text-red-700 font-semibold">
									{displayMessage("DESCRIPTION")}:
								</span>
							}
							name="description"
							className={`w-full m-0`}
							initialValue={""}
						>
							<SL_Input
								textarea={true}
								rows={2}
								type="text"
								className="text-red-700"
							/>
						</Form.Item>

						<div className="gap-4 flex w-full flex-col smb:flex-row mt-2">
							<Form.Item
								label={
									<span className="text-red-700 font-semibold">
										{displayMessage("DURATION_MINUTES")}:
									</span>
								}
								name="duration_minutes"
								className={`w-full m-0`}
								initialValue={null}
							>
								<SL_Input type="number" className="text-red-700" />
							</Form.Item>

							<Form.Item
								label={
									<span className="text-red-700 font-semibold">
										{displayMessage("ORDER_INDEX")}:
									</span>
								}
								name="order_index"
								className={`w-full m-0`}
								initialValue={0}
							>
								<SL_Input type="number" className="text-red-700" />
							</Form.Item>
						</div>
					</>
				)}
			</Form>
		</Modal>
	);
}


